(ns manage.adset.util
  (:require ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            [common.form :as form]
            [manage.adset.business-logic :as business-logic]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]))

(def channel-options
  (map (fn [[key map]]
         (assoc map :value (name key)))
       business-logic/channels))

(defui info-switch [{:keys [label tooltip name control]}]
  ($ form/switch
     {:label ($ Stack {:direction "row" :alignItems "center" :gap 1
                       :sx #js {:ml 1}}
                label
                ($ Tooltip
                   {:title ($ Typography tooltip)
                    :placement "right"}
                   ($ Icon "info_outlined")))
      :name name
      :control control}))

(defui automated-workflow-switches
  [{:keys [control social-adset?]}]
  ($ :<>
     ($ Divider)
     ($ Stack {:gap 2}
        ($ Typography {:variant "h3"} "Automated workflows")
        (when social-adset?
          ($ info-switch
             {:label "Auto enable activation rows"
              :tooltip "This determines whether the Activation Rows are enabled by default when the Decision Tree is published."
              :name "autoEnable"
              :control control}))
        ($ info-switch
           {:label "Auto Approval"
            :tooltip "Automatically approve ad variants after validation passes, skipping the manual approval step."
            :name "autoApproveAdVariants"
            :control control})
        ($ info-switch
           {:label "Auto publishing"
            :tooltip "When Ads are assigned to a Decision Tree and some of them have a version bump or a state transition from draft to ready, the Decision Tree will be updated and re-published automatically."
            :name "autoPublishing"
            :control control}))))

(defui channel-icon
  [{:keys [channel]}]
  (when-let [{:keys [icon label]} (get business-logic/channels (keyword channel))]
    ($ Tooltip
       {:placement :bottom
        :title label}
       ($ SvgIcon
          ($ icon)))))

(defn landing-route-from-workflow [workflow]
  (case workflow
    "ad-variants" :adset/ad-variants
    "content-variants" :adset/content-variants
    "rules" :adset/content-configuration
    nil))

(defn landing-params-from-workflow [workflow url-context]
  (cond-> url-context
    (#{"content-variants" "rules"} workflow) (assoc :content-function-version "draft")))

(defn landing-url-from-workflow [workflow url-context]
  (let [route (landing-route-from-workflow workflow)
        params (landing-params-from-workflow workflow url-context)]
    (some-> route (r.easy/href params))))

(defn navigate-to-landing-page [workflow url-context]
  (let [route (landing-route-from-workflow workflow)
        params (landing-params-from-workflow workflow url-context)]
    (when route
      (r.easy/navigate route {:path-params params}))))

(defn target-type->channel
  [target-type]
  (->> business-logic/channels
       (keep (fn [[channel config]]
               (when (= (:target-type config) target-type)
                 channel)))
       first))
